import { render } from "./managementTeam.vue?vue&type=template&id=742a49fc&scoped=true"
import script from "./managementTeam.vue?vue&type=script&lang=js"
export * from "./managementTeam.vue?vue&type=script&lang=js"

import "./managementTeam.vue?vue&type=style&index=0&id=742a49fc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-742a49fc"]])

export default __exports__